import { styled, Theme } from "@mui/material/styles";
import { Box } from "@mui/material";

type ContainerProps = {
  isAI: boolean;
  messageIndex: number;
};

export const Container = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isAI" && prop !== "messageIndex",
})(({ isAI, messageIndex }: ContainerProps) => ({
  display: "flex",
  flexDirection: isAI ? "row" : "row-reverse",
  alignItems: "end",
  width: "100%",
  marginTop: messageIndex === 0 ? "auto" : 0,
}));

type AvatarContainerProps = {
  theme: Theme;
  isAI: boolean;
};

export const AvatarContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isAI",
})(({ theme, isAI }: AvatarContainerProps) => ({
  borderRadius: 999,
  flexShrink: 0,
  border: `1px solid ${isAI ? theme.palette.success.main : theme.palette.primary.main}`,
  marginBottom: "5px",
}));

type MessageContainerProps = {
  theme: Theme;
  isAI: boolean;
};

export const MessageContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isAI",
})(({ theme, isAI }: MessageContainerProps) => ({
  backgroundColor: theme.palette.background.default,
  borderRadius: "10px",
  borderLeft: `2px solid ${isAI ? theme.palette.success.main : theme.palette.background.paper}`,
  borderRight: `2px solid ${isAI ? theme.palette.background.paper : theme.palette.primary.main}`,
  textAlign: `${isAI ? "left" : "right"}`,
  borderTop: `2px solid ${theme.palette.background.paper}`,
  borderBottom: `2px solid ${theme.palette.background.paper}`,
  paddingLeft: "30px",
  paddingRight: "30px",
  paddingTop: "10px",
  paddingBottom: "10px",
  maxWidth: "80%",
  display: "flex",
}));

export const MessageBox = styled(Box)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "14px",
  animation: "blink 0.5s steps(2, start) infinite",
  "@keyframes blink": {
    "50%": { borderRightColor: "transparent" },
  },
  "> p": {
    margin: 0,
  },
}));
